<template>
  <section class="py-2 bg-white text-center container">
    <h2 class="font-weight-bold h2">What Our Customers Say</h2>
    <p class="mt-2 text-muted">
      Over 1,000+ satisfied customers across Englewood and surrounding areas
      trust us with their garage door needs. Read what they have to say about
      our service.
    </p>

    <div
      class="d-block d-sm-flex justify-content-center align-items-center my-3"
    >
      <div class="stars mr-2 d-flex d-sm-block justify-content-center">
        <svg
          v-for="n in 5"
          :key="n"
          xmlns="http://www.w3.org/2000/svg"
          class="star"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 
              3.967a1 1 0 00.95.69h4.178c.969 
              0 1.371 1.24.588 1.81l-3.385 
              2.46a1 1 0 00-.364 1.118l1.287 
              3.966c.3.922-.755 1.688-1.54 
              1.118l-3.385-2.46a1 1 0 
              00-1.176 0l-3.385 2.46c-.784.57-1.838-.196-1.539-1.118l1.287-3.966a1 
              1 0 00-.364-1.118l-3.385-2.46c-.783-.57-.38-1.81.588-1.81h4.178a1 
              1 0 00.95-.69l1.287-3.967z"
          />
        </svg>
      </div>
      <h4 class="mb-0 font-weight-bold">
        4.9
        <small class="text-muted ml-2 reveiws">/ 5 based on 250+ reviews</small>
      </h4>
    </div>

    <div class="row mt-4">
      <div
        class="col-md-4 mb-4"
        v-for="(review, index) in reviews"
        :key="index"
      >
        <div class="card h-100 shadow-sm border-0">
          <div class="card-body text-left">
            <div class="stars mb-2">
              <svg
                v-for="n in 5"
                :key="n"
                xmlns="http://www.w3.org/2000/svg"
                class="star"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.286 
                    3.967a1 1 0 00.95.69h4.178c.969 
                    0 1.371 1.24.588 1.81l-3.385 
                    2.46a1 1 0 00-.364 1.118l1.287 
                    3.966c.3.922-.755 1.688-1.54 
                    1.118l-3.385-2.46a1 1 0 
                    00-1.176 0l-3.385 2.46c-.784.57-1.838-.196-1.539-1.118l1.287-3.966a1 
                    1 0 00-.364-1.118l-3.385-2.46c-.783-.57-.38-1.81.588-1.81h4.178a1 
                    1 0 00.95-.69l1.287-3.967z"
                />
              </svg>
            </div>
            <p class="card-text">"{{ review.message }}"</p>
            <hr />
            <h6
              class="font-weight-bold mb-0 d-flex justify-content-between flex-column"
            >
              <span>{{ review.name }}</span>
              <router-link
                :to="'/services/' + review.slug"
                class="text-primaryblue font-weight-bold"
                >{{ review.service }}</router-link
              >
            </h6>
            <p class="text-muted mb-0">{{ review.location }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-4">
      <p class="mb-2">
        Join hundreds of satisfied customers in Englewood and surrounding areas
      </p>
      <a
        href="tel:5514080587"
        class="btn btn-primaryblue font-weight-bold mr-2 mt-3 mt-sm-0"
      >
        Call (551) 408-0587
      </a>
      <a
        href="tel:5514080587"
        class="btn btn-outline-primaryblue font-weight-bold mt-3 mt-sm-0"
      >
        Get Free Quote
      </a>
    </div>
  </section>
</template>

<script>
export default {
  name: "CustomerTestimonials",
  data() {
    return {
      reviews: [
        {
          name: "Sarah Johnson",
          location: "Englewood, NJ",
          service: "New Garage Door Installations",
          slug: "new-garage-door-installations-residential-commercial",
          message:
            "NextGen Garage Door Repairs saved the day! My garage door spring snapped at 7 AM and they had it fixed by noon. Professional, affordable, and incredibly fast service.",
        },
        {
          name: "Mike Rodriguez",
          location: "Bergenfield, NJ",
          service: "Door Replacement",
          slug: "replacement-old-damaged-doors",
          message:
            "Outstanding work on our new garage door installation. The team was punctual, clean, and the door looks amazing. Their warranty coverage gives us complete peace of mind.",
        },
        {
          name: "Jennifer Chen",
          location: "Fort Lee, NJ",
          service: "Emergency Repair",
          slug: "emergency-stuck-doors",
          message:
            "Called them for an emergency late at night when our garage door wouldn't close. They responded within an hour and had us secured safely. Truly 24/7 service!",
        },
        {
          name: "David Thompson",
          location: "Teaneck, NJ",
          service: "Spring Replacement",
          slug: "broken-spring-replacement",
          message:
            "Family-owned business that really cares about their customers. Fair pricing, excellent communication, and top-quality work. Highly recommend for any garage door needs.",
        },
        {
          name: "Lisa Martinez",
          location: "Tenafly, NJ",
          service: "Opener Repair",
          slug: "opener-repair-and-troubleshooting",
          message:
            "Impressed by their professionalism and expertise. They diagnosed the problem quickly and explained everything clearly. The repair has been working perfectly for months.",
        },
        {
          name: "Robert Kim",
          location: "Leonia, NJ",
          service: "Cable Repair",
          slug: "cable-repair-replacement",
          message:
            "Best garage door company in the area! They've serviced our commercial warehouse doors for 3 years now. Always reliable, always professional.",
        },
      ],
    };
  },
};
</script>

<style scoped>
.card {
  border-radius: 1rem;
  transition: all 0.3s ease-in-out;
}
.card:hover {
  transform: scale(1.05);
  box-shadow: 0 12px 25px rgba(0, 0, 0, 0.2);
}
.card-text {
  font-size: 0.95rem;
}
.stars {
  display: flex;
}
.star {
  width: 20px;
  height: 20px;
  color: #ffc107;
  margin-right: 2px;
}
.reveiws {
  font-size: 16px;
}

.btn-primaryblue {
  background-color: #0d47a1;
  border-color: #0d47a1;
  color: white;
}

.btn-primaryblue:hover {
  background-color: #0a1f5b;
  border-color: #0a1f5b;
  color: white;
}

.btn-outline-primaryblue {
  color: #0d47a1;
  border-color: #0d47a1;
}

.btn-outline-primaryblue:hover {
  background-color: #0d47a1;
  border-color: #0d47a1;
  color: white;
}

.text-primaryblue {
  color: #0d47a1 !important;
}
</style>
